import type { Message } from '@langchain/langgraph-sdk'

/**
 * Extracts text content from a message.
 * Handles both string and array content formats.
 */
export function getContentString(content: Message['content']): string {
    if (typeof content === 'string') return content

    // Extract text blocks from array content
    const texts = content.filter((c): c is { type: 'text'; text: string } => c.type === 'text').map((c) => c.text)

    return texts.join(' ')
}
